import React from 'react';
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import Colors from "../../components/ui/Colors";
import swal from "sweetalert";
import { changeDealsDefinitions } from "../../utilityFunctions/DealsUtil";
import { Box } from '@mui/system';
import Grid from '@mui/material/Grid';
import {Typography, Button} from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";



const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dealsTypes = [
    {
        label: "Cliente fiducia a fondo",
        type: "PRF"
    },
    {
        label: "Adquirente a fondo",
        type: "ADF"
    },
    {
        label: "Cliente VIP a fondo",
        type: "VFO"
    },
    {
        label: "Cliente interesante para fiducia",
        type: "IPR"
    },
    {
        label: "Cliente VIP a Promotor",
        type: "VPR"
    },
    {
        label: "Promotor a promotor",
        type: "PRP"
    },
    {
        label: "Cliente fondo a fondo",
        type: "FOF"
    },
];

const levels = [
    {
        level: "high",
        label: "Alto",
    },
    {
        level: "medium",
        label: "Medio",
    },
    {
        level: "low",
        label: "Bajo",
    },
];

const jobs = [
    {
        job: "directorObra",
        label: "Director obra",
    },
    {
        job: "ejecutivoConstructora",
        label: "Ejecutivo constructora",
    },
    {
        job: "cfoConstructor",
        label: "Financiero en constructora",
    },
];

const actions = [
    {
        action: "comercialEmailResponse",
        label: "Respuesta correo comercial",
    },
    {
        action: "calllResponse",
        label: "Respuesta llamada",
    },
    {
        action: "calllResponse",
        label: "Respuesta llamada",
    },
];

const potentialValues = [
    {
        potentialValue: "valueFraction",
        label: "Porcentaje productos"
    },
    {
        potentialValue: "byIncome",
        label: "Porcentaje ingresos"
    },
];

let dealsDefinitions = {
    name: "",
    description: "",
    type: "",
    potentialValue: "",
    level: "",
    realStateNumber: "",
    realStateValue: "",
    realStateDate: "",
    averageInvestment: "",
    daysWithdraw: "",
    job: "",
    vip: "",
    action: "",
    income: "",
};

export default function ChangeDealsDefinitions(props) {

    const {loginUser} = props 

    let history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const [name, setName] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [type, setType] = React.useState("");
    const [potentialValue, setPotentialValue] = React.useState("");
    const [level, setLevel] = React.useState("");
    const [realStateNumber, setRealStateNumber] = React.useState("");
    const [realStateValue, setRealStateValue] = React.useState("");
    const [realStateDate, setRealStateDate] = React.useState("");
    const [averageInvestment, setAverageInvestment] = React.useState("");
    const [daysWithdraw, setDaysWithdraw] = React.useState("");
    const [job, setJob] = React.useState("");
    const [vip, setVip] = React.useState("");
    const [action, setAction] = React.useState("");
    const [income, setIncome] = React.useState("");

    React.useEffect(() => {
        loadDefinitions();
    }, []);

    const loadDefinitions = () => {
        if(props.location.state && props.location.state.dealsDefinitions){
            dealsDefinitions = props.location.state.dealsDefinitions;
            
            if(dealsDefinitions.name){
                setName(dealsDefinitions.name);
            }
            if(dealsDefinitions.type){
                setType(dealsDefinitions.type);
            }
            if(dealsDefinitions.description){
                setDescription(dealsDefinitions.description);
            }
            if(dealsDefinitions.potentialValue){
                setPotentialValue(dealsDefinitions.potentialValue);
            }
            if(dealsDefinitions.level){
                setLevel(dealsDefinitions.level);
            }
            if(dealsDefinitions.realStateNumber){
                setRealStateNumber(dealsDefinitions.realStateNumber);
            }
            if(dealsDefinitions.realStateValue){
                setRealStateValue(dealsDefinitions.realStateValue);
            }
            if(dealsDefinitions.realStateDate){
                setRealStateDate(dealsDefinitions.realStateDate);
            }
            if(dealsDefinitions.averageInvestment){
                setAverageInvestment(dealsDefinitions.averageInvestment);
            }
            if(dealsDefinitions.daysWithdraw){
                setDaysWithdraw(dealsDefinitions.daysWithdraw);
            }
            if(dealsDefinitions.job){
                setJob(dealsDefinitions.job);
            }
            if(dealsDefinitions.vip){
                setVip(dealsDefinitions.vip);
            }
            if(dealsDefinitions.action){
                setAction(dealsDefinitions.action);
            }
            if(dealsDefinitions.income){
                setIncome(dealsDefinitions.income);
            }
        }
    };

    const handleChange = (event, definition) => {
        // console.log(dealsDefinitions)
        // console.log(event)
        // console.log(definition)
        switch(definition){
            case "name":
                dealsDefinitions.name=event.target.value;
                setName(event.target.value);
                break;
            case "description":
                dealsDefinitions.description=event.target.value;
                setDescription(event.target.value);
                break;
            case "type":
                dealsDefinitions.type=event.target.value;
                setType(event.target.value);
                break;
            case "potentialValue":
                dealsDefinitions.potentialValue=event.target.value;
                setPotentialValue(event.target.value);
                break;
            case "level":
                dealsDefinitions.level=event.target.value;
                setLevel(event.target.value);
                break;
            case "realStateNumber":
                dealsDefinitions.realStateNumber=event.floatValue; 
                setRealStateNumber(event.floatValue);
                break; 
            case "realStateValue":
                dealsDefinitions.realStateValue=event.floatValue; 
                setRealStateValue(event.floatValue);
                break; 
            case "realStateDate":
                dealsDefinitions.realStateDate=event.floatValue;
                setRealStateDate(event.floatValue);
                break;
            case "averageInvestment":
                dealsDefinitions.averageInvestment=event.floatValue;
                setAverageInvestment(event.floatValue);
                break;
            case "daysWithdraw":
                dealsDefinitions.daysWithdraw=event.floatValue;
                setDaysWithdraw(event.floatValue);
                break;
            case "job":
                dealsDefinitions.job=event.target.value;
                setJob(event.target.value);
                break;
            case "vip":
                dealsDefinitions.vip=event.target.value;
                setVip(event.target.value);
                break;
            case "action":
                dealsDefinitions.action=event.target.value;
                setAction(event.target.value);
                break;
            case "income":
                dealsDefinitions.income=event.floatValue;
                setIncome(event.floatValue);
                break;

            default:
                break;
        }
    };

    const submitModifications = async () =>{
        setLoading(true);
        const result = await changeDealsDefinitions(dealsDefinitions, loginUser.jwtToken);
        if(result){

            swal({
                title: "Cambio Exitoso",
                icon: "success",
                button: "Entiendo",
            }).then(() => {
                history.push({pathname: "/handle_profile"});
            });
        }else{
            swal({
                title: "Cambio No Exitoso",
                icon: "error",
                button: "Entiendo",
            });
        }
        setLoading(false);
    };

    const handleBack = () => {
        history.push({pathname: "/commercial/nreviewdealsdef"});
    };


    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    // flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    width: "95%",
                    height: "100%",
                    textAlign: "center",
                    marginTop: {xs: "1.3rem", sm: 0},
                }}
            >

            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            fullWidth={true}
                            id="dealName"
                            name="dealName"
                            label={<Typography variant="body2">Nombre oportunidad</Typography>}
                            value={name}
                            onChange={(e)=>handleChange(e, "name")}
                            autoComplete="off"
                        />    
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            multiline
                            autoComplete="off"
                            fullWidth={true}
                            id="description"
                            name="description"
                            label={<Typography variant="body2">Descripción oportunidad</Typography>}
                            InputProps={{ style: { fontSize: 12 } }}
                            value={description}
                            onChange={(e)=>handleChange(e, "description")}
                        />    
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            fullWidth={true}
                            id="type"
                            name="type"
                            select
                            label={<Typography variant="body2">Tipo oportunidad</Typography>}
                            value={type}
                            onChange={(e)=>handleChange(e, "type")}
                            autoComplete="off"
                        >
                            {dealsTypes.map((type) => (
                                <MenuItem key={type.type} value={type.type}>
                                    {type.label}
                                </MenuItem>
                            ))}
                        </TextField>
                            
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            fullWidth={true}
                            id="potentialValue"
                            name="potentialValue"
                            select
                            label={<Typography variant="body2">Valor potencial</Typography>}
                            value={potentialValue}
                            onChange={(e)=>handleChange(e, "potentialValue")}
                            autoComplete="off"
                        >
                            {potentialValues.map((valueEl) => (
                                <MenuItem key={valueEl.potentialValue} value={valueEl.potentialValue}>
                                    {valueEl.label}
                                </MenuItem>
                            ))}
                        </TextField> 
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            autoComplete="off"
                            fullWidth={true}
                            id="level"
                            name="level"
                            select
                            label={<Typography variant="body2">Nivel oportunidad</Typography>}
                            value={level}
                            onChange={(e)=>handleChange(e, "level")}
                        >
                            {levels.map((level) => (
                                <MenuItem key={level.level} value={level.level}>
                                    {level.label}
                                </MenuItem>
                            ))}
                        </TextField>  
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <NumberFormat
                            variant="standard"
                            style={{width: "100%", height: "50%"}}
                            name="realStateNumber"
                            customInput={TextField}
                            // prefix={'$ '}
                            type="text"
                            label={<Typography variant="body2">Cantidad negocios inmobiliarios</Typography>}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            autoComplete="off"
                            value={realStateNumber}
                            onValueChange={(values) => {
                                // const {formattedValue, value, floatValue} = values;
                                handleChange(values, "realStateNumber");
                            }}
                        />
                    </Grid>  
                    <Grid item xs={12} sm={6} md={6}>
                        <NumberFormat
                            variant="standard"
                            style={{width: "100%", height: "50%"}}
                            name="realStateValue"
                            customInput={TextField}
                            prefix={'$ '}
                            type="text"
                            label={<Typography variant="body2">Valor negocios inmobiliarios</Typography>}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            autoComplete="off"
                            value={realStateValue}
                            onValueChange={(values) => {
                                // const {formattedValue, value, floatValue} = values;
                                handleChange(values, "realStateValue");
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <NumberFormat
                            variant="standard"
                            style={{width: "100%", height: "50%"}}
                            name="realStateDate"
                            customInput={TextField}
                            // prefix={'$ '}
                            type="text"
                            label={<Typography variant="body2">Días desde último negocio</Typography>}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            autoComplete="off"
                            value={realStateDate}
                            onValueChange={(values) => {
                                // const {formattedValue, value, floatValue} = values;
                                handleChange(values, "realStateDate");
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <NumberFormat
                            variant="standard"
                            style={{width: "100%", height: "50%"}}
                            name="averageInvestment"
                            customInput={TextField}
                            prefix={'$ '}
                            type="text"
                            label={<Typography variant="body2">Inversión promedio fondo</Typography>}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            autoComplete="off"
                            value={averageInvestment}
                            onValueChange={(values) => {
                                // const {formattedValue, value, floatValue} = values;
                                handleChange(values, "averageInvestment");
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <NumberFormat
                            variant="standard"
                            style={{width: "100%", height: "50%"}}
                            name="daysWithdraw"
                            customInput={TextField}
                            // prefix={'$ '}
                            type="text"
                            label={<Typography variant="body2">Días desde retiro fondo</Typography>}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            autoComplete="off"
                            value={daysWithdraw}
                            onValueChange={(values) => {
                                // const {formattedValue, value, floatValue} = values;
                                handleChange(values, "daysWithdraw");
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            autoComplete="off"
                            fullWidth={true}
                            id="job"
                            name="job"
                            select
                            label={<Typography variant="body2">Sector económico</Typography>}
                            value={job}
                            onChange={(e)=>handleChange(e, "job")}
                        >
                            {jobs.map((job) => (
                                <MenuItem key={job.job} value={job.job}>
                                    {job.label}
                                </MenuItem>
                            ))}
                        </TextField>  
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            autoComplete="off"
                            fullWidth={true}
                            id="vip"
                            name="vip"
                            select
                            label={<Typography variant="body2">Cliente VIP</Typography>}
                            value={vip}
                            onChange={(e)=>handleChange(e, "vip")}
                        >
                            <MenuItem value={false}>No</MenuItem>
                            <MenuItem value={true}>Sí</MenuItem>
                        </TextField>  
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            variant="standard"
                            autoComplete="off"
                            fullWidth={true}
                            id="action"
                            name="action"
                            select
                            label={<Typography variant="body2">Acción cliente</Typography>}
                            value={action}
                            onChange={(e)=>handleChange(e, "action")}
                        >
                            {actions.map((action) => (
                                <MenuItem key={action.action} value={action.action}>
                                    {action.label}
                                </MenuItem>
                            ))}
                        </TextField>  
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <NumberFormat
                            variant="standard"
                            style={{width: "100%", height: "50%"}}
                            name="income"
                            customInput={TextField}
                            prefix={'$ '}
                            type="text"
                            label={<Typography variant="body2">Ingresos cliente</Typography>}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            autoComplete="off"
                            value={income}
                            onValueChange={(values) => {
                                // const {formattedValue, value, floatValue} = values;
                                handleChange(values, "income");
                            }}
                        />
                    </Grid>             
                    <Grid item xs={6} sm={6} md={6} sx={{marginTop: "1.5rem", display: "flex", justifyContent: "end"}}>
                        <Button onClick={handleBack} sx={{backgroundColor: Colors.primary, color: "white", width: "5.5rem", marginRight: "1.5rem", '&.MuiButton-root:hover':{bgcolor: Colors.hover}}}>
                            Atrás
                        </Button>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} sx={{marginTop: "1.5rem", display: "flex", justifyContent: "start"}}>
                        <Button onClick={submitModifications} sx={{backgroundColor: Colors.primary, color: "white", marginLeft: "1.5rem", '&.MuiButton-root:hover':{bgcolor: Colors.hover}}}>
                            Cambiar
                        </Button>
                    </Grid>
                </Grid>
            }
            </Box>
        </Box>
    )
}
